/* eslint @typescript-eslint/no-var-requires: "off" */
import * as api from "../../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Utils from "../../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";


// const api = require("../../constant/API");

const Nutritionist = () => {

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState("");
    const [institutionList, setInstitutionList] = useState([]);
    const [nutritionistList, setNutritionist] = useState([]);
    const [instId, setInstId] = useState("");
    const [openModal, setOpenModal] = useState(false)

    const formRef = useRef(null);

    useEffect(() => {
        getCoachList();
        getInstituteList();
    }, [])

    function getCoachList() {
        const getCochLst = api.getNutritionistList //+ "?userId=" + userId + "&roleId=" + roleId;
        fetch(getCochLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.error == true) {
                    if (lstResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (lstResult.data != null) {
                        setNutritionist(lstResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the nutritionist list", error)
            })
    }

    function getInstituteList() {
        const getInstList = api.NutritionistInstitutionList + "/" + roleId;
        fetch(getInstList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((insResponse) => insResponse.json())
            .then((insResult) => {
                if (insResult.error == true) {
                    if (insResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (insResult.data != null) {
                        setInstitutionList(insResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the institution list", error);
            })
    }

    function initialVals() {
        setOpenModal(true);
        setInstId("");
        setNutritionist("");
    }

    function saveNutritionist(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            // console.log("Saved Nutritionist");
            alert("Coming Soon..!");
            setOpenModal(false)
        }
    }

    const filteredData = nutritionistList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const instituteRender = (rowData) => {
        return <span>{rowData.InstitutionName}</span>
    }

    const sprtRender = (rowData) => {
        return <span>{rowData.SportName}</span>
    }

    const coachRender = (rowData) => {
        return <span>{rowData.CoachName}</span>
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {(roleId == 1 || roleId == 5) ? (
                                            <>
                                                <div className="row col-lg-6 court-sortby sortbyset">
                                                    <div className="col-lg-6 col-sm-6">
                                                        <Link
                                                            className="btn btn-secondary"
                                                            to="#"
                                                            onClick={initialVals}
                                                        >
                                                            <i className="fas fa-user-clock" />&nbsp;
                                                            Assign Nutritionist
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="InstitutionName"
                                                    body={instituteRender}
                                                    header="Institute"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="Nutritionist"
                                                    header="Nutritionist"
                                                    body={sprtRender}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Assign Nutritionist Modal */}
            <Modal
                show={openModal}
                size="md"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case"><i className="fas fa-user-check" />Assign Nutritionist</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Institute</label>
                                <Select
                                    required
                                    value={institutionList.find(ins => ins.institutionId === instId) ? {
                                        label: institutionList.find(ins => ins.institutionId === instId).institutionName
                                    } : null}
                                    onChange={(e) => {
                                        setInstId(e.value);
                                        //     setError("");
                                    }}
                                    placeholder="Select Institute"
                                    options={institutionList.map(ins => ({
                                        value: ins.institutionId,
                                        label: ins.institutionName
                                    }))}
                                >
                                </Select>
                            </div>
                            {/* {error && <div className="alert alert-danger">{error}</div>} */}
                        </div>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Nutritionist</label>
                                <Select
                                    required
                                    placeholder="Select Nutritionist">

                                </Select>
                            </div>
                            {/* {nameError && <div className="alert alert-danger">{nameError}</div>} */}
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        onClick={saveNutritionist}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />Save</b>
                    </Button>
                </ModalFooter>
            </Modal>
            {/* /Assign Nutritionist Modal */}
        </>
    );
}

export default Nutritionist;